<template>
  <div>
    <el-form @submit.native.prevent="createAuthor">
      <el-autocomplete
        v-model="authorScreenname"
        :trigger-on-focus="false"
        :highlight-first-item="highlightFirstItem"
        :fetch-suggestions="authorFilter"
        ref="autocomplete"
        prefix-icon="el-icon-search"
        placeholder="Rechercher"
        @keyup.enter.native=""
        @select="selectAuthor"></el-autocomplete>
        <!-- {{ author }} -->
    </el-form>
  </div>
</template>
<script>
  export default {
    name: 'story-author-selector',
    props: {
      author: Object,
      selectFunction: Function,
      createFunction: Function,
      highlightFirstItem: {
        type: Boolean,
        default: true
      }
    },
    data () {
      return {
        authorScreenname: null
      }
    },
    watch: {
      'author' (to, from) {
        if (to) {
          this.authorScreenname = to.label
        }
      }
    },
    methods: {
      authorFilter(queryString, cb) {
        if (queryString) {
          this.axios.get('/authors/', {
            params: {
              term: queryString,
              status: 'ENABLED',
              limit: 100},
            headers: {'x-fields': 'id,screenname'}
          }).then((response) => {
            var list = []
            response.data.results.map(function (value, key) {
              list.push({value: `${value.screenname}`, id: value.id, author: value})
            })
            cb(list)
          })
        }
      },
      selectAuthor(value) {
        if (value) {
          this.selectFunction(value.author)
        }
      },
      createAuthor(value) {
        if (this.authorScreenname) {
          this.createFunction(this.authorScreenname)
        }
      },
      clearInput() {
        this.authorScreenname = ''
      }
    }
  }
</script>
<style scoped>

.el-autocomplete {
  display: block;
}
</style>
